import { createSlice } from "@reduxjs/toolkit"

// create slice
const chatbotInfo = createSlice({
  name: "chatbotInfo",
  initialState: {
    sessionId: "",
    topicId: -1,
    resetMemory: false,
    messageList: [],
  },
  reducers: {

    setSessionId (state, action) {
      state.sessionId = action.payload
    },

    setTopicId (state, action) {
      state.topicId = action.payload
    },

    setResetMemory (state, action) {
      state.resetMemory = action.payload
    },

    setMessageList (state, action) {
      state.messageList = action.payload
    }
  }
})
// action: {type: name/functionName, payLoad: param}
export const { setSessionId, setMessageList, setTopicId, setResetMemory } = chatbotInfo.actions
export default chatbotInfo.reducer